import { render, staticRenderFns } from "./ComplaintTable.vue?vue&type=template&id=11fe464d&"
import script from "./ComplaintTable.vue?vue&type=script&lang=js&"
export * from "./ComplaintTable.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintTable.vue?vue&type=style&index=0&id=11fe464d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports